import React from "react";
import { connect } from "react-redux";
import { array, func, object, bool, number, oneOfType } from "prop-types";
import { shareResults, getUsersAndTeams } from "../actions";
import ShareTestResultsComponent from "../actionComponents/ShareTestResultsComponent";

// eslint-disable-next-line react/prefer-stateless-function
export class ShareTestResults extends React.PureComponent {
  render() {
    const {
      users,
      teams,
      candidateIds,
      onGetUsersAndTeams,
      onShareResults,
      changeAction,
      userData,
      fromBulkShareTestResults,
      shareResultsSuccess,
      showShareResultsLoader,
      showWorkStyles,
      companyInfo,
      featureFlags,
      candidateStatus,
      isEPPCompleted,
    } = this.props;

    const isInsightUser = userData && userData.partnerAccountId === 47;
    const permissionScoreReports = userData && userData.permissionScoreReports;
    const hsVersion = companyInfo && companyInfo.get("hsVersion");
    const showManagerGuideTab =
      featureFlags && featureFlags.get("showManagerGuideTab");

    return (
      <ShareTestResultsComponent
        users={users}
        teams={teams}
        candidateIds={candidateIds}
        onGetUsersAndTeams={onGetUsersAndTeams}
        onShareResults={onShareResults}
        changeAction={changeAction}
        showShareResultsLoader={showShareResultsLoader}
        fromBulkShareTestResults={fromBulkShareTestResults}
        shareResultsSuccess={shareResultsSuccess}
        isInsightUser={isInsightUser}
        permissionScoreReports={permissionScoreReports}
        showWorkStyles={showWorkStyles}
        hsVersion={hsVersion}
        showManagerGuideTab={showManagerGuideTab}
        candidateStatus={candidateStatus}
        isEPPCompleted={isEPPCompleted}
      />
    );
  }
}

ShareTestResults.propTypes = {
  users: object,
  teams: object,
  candidateIds: array,
  changeAction: func,
  onGetUsersAndTeams: func,
  onShareResults: func,
  userData: object,
  showShareResultsLoader: bool,
  fromBulkShareTestResults: bool,
  shareResultsSuccess: bool,
  showWorkStyles: bool,
  companyInfo: object,
  featureFlags: object,
  candidateStatus: number,
  isEPPCompleted: oneOfType([bool, object]),
};

const mapStateToProps = (state) => ({
  users: state.get("results").get("users"),
  teams: state.get("results").get("teams"),
  userData: state.get("App").get("userData"),
  showShareResultsLoader: state.get("results").get("showShareResultsLoader"),
  shareResultsSuccess: state.get("results").get("shareResultsSuccess"),
  featureFlags: state.get("App").get("featureFlags"),
  companyInfo: state.get("App").get("companyInfo"),
});

const mapDispatchToProps = (dispatch) => ({
  onGetUsersAndTeams: () => dispatch(getUsersAndTeams()),
  onShareResults: (dataObj) => dispatch(shareResults(dataObj)), // {"userAccountIds":[57659],"teamIds":[1,2],"testTakerIds":[2747141,2747142],"options":{"report":true,"workplaceInsights":false,"workStyles":false,"summary":false,"application":false,"resume":false,"documents":false}}
});

export default connect(mapStateToProps, mapDispatchToProps)(ShareTestResults);
